import axios from 'axios';

export function checkInput(address) {
  let ok = true;
  Object.keys(address).forEach((key) => {
    if ((address[key] === '' || address[key] === null)
      && key !== 'co'
      && key !== 'note'
      && key !== 'address2'
      && key !== 'alias'
      && key !== 'deleted_at'
      && key !== 'street_number') {
      ok = false;
    }
  });
  return ok;
}

export function isValidTaxNumber(givenTaxNumber) {
  const taxNumber = givenTaxNumber.trim();
  if (taxNumber.match(/^[0-9]+$/) || taxNumber.length !== 16) {
    return false;
  }
  return true;
}

export function TaxNumberValidation(givenTaxNumber) {
  const taxNumber = givenTaxNumber.trim();
  return axios.post('/api/check-codicefiscale', { codice_fiscale: taxNumber });
}

export function saveNewAddress(customerId, address) {
  return axios.post(`/api/customers/${customerId}/addresses`, address);
}

export function updateGivenAddress(address) {
  return axios.put(`/api/addresses/${address.id}`, address);
}
